const config = {
    id: 20,
    name: "红包雨",
    type: 1,
    module_code: "biz_red_packet",
    icon: "icon-tms-red-packet",
    font_icon: "&#xe6af;",
    style_type: 1,
    link_type: 0,
    property_data: {
        background_color: "#FFFFFF",
        input_background_color: "#F3F4F5",
        search_scope: 1,
        show_fix: 1,
        search_hint: "红包雨"
    }
};
export default config;